/**
 * @file index.tsx
 *
 * @fileoverview Renders a call to action row.
 */

import React from 'react';
import { CtaSimpleParagraph } from '~/jobiqo/types/types';
import { RowButtons } from '../RowButtons';
import { Text } from '~/vcl/atoms/13-text/03-text';
import { Box } from '~/vcl/atoms/07-box';
import { Main } from '~/vcl/atoms/06-layout/09-main';
import { Grid } from '~/vcl/atoms/06-layout/04-grid';
import { Cell } from '~/vcl/atoms/06-layout/04-grid/01-cell';
import { FlexItems } from '~/vcl/atoms/06-layout/03-flex';
import { getFrontendTheme } from '~/jobiqo/utils/getFrontend';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';

interface CTASimpleProps {
  row: CtaSimpleParagraph;
  maxContainerSize?: 'small' | 'medium' | 'large' | 'xLarge';
}
export const CTASimple = ({ row, maxContainerSize }: CTASimpleProps) => {
  const frontendConfig = useFrontendConfig();
  const frontendTheme = getFrontendTheme(frontendConfig);
  return (
    <Box
      boxShadow="none"
      borderRadius="0px"
      paddingTop={row.spacing ?? 12}
      paddingBottom={row.spacing ?? 12}
      paddingLeft={[6, 12]}
      paddingRight={[6, 12]}
      marginTop={0}
      backgroundColorOverride={
        row.background ? `var(--color-${row.background})` : `var(--color-white)`
      }
    >
      <Main {...(maxContainerSize ? { size: maxContainerSize } : null)}>
        <Grid alignItems="center" columns={[1, 3]}>
          <Cell gridColumn={'span 2'} gridRow={1}>
            <FlexItems
              gap={2}
              flexDirection={
                frontendTheme.LANDING_PAGES.CTA_SIMPLE.TITLE_ABOVE_SUBTITLE
                  ? 'column'
                  : 'column-reverse'
              }
            >
              <Text tag="h2" fontSize={[6, 8]} lineHeight={[6, 7]}>
                {row.title}
              </Text>
              <Text
                fontSize={
                  frontendTheme.LANDING_PAGES.CTA_SIMPLE.SUBTITLE_FONT_SIZE
                }
                lineHeight={
                  frontendTheme.LANDING_PAGES.CTA_SIMPLE.SUBTITLE_LINE_HEIGHT
                }
                fontWeight={
                  frontendTheme.LANDING_PAGES.CTA_SIMPLE.SUBTITLE_FONT_WEIGHT
                }
                color={
                  frontendTheme.LANDING_PAGES.CTA_SIMPLE.SUBTITLE_COLOR ??
                  (row.color as any)
                }
              >
                {row.subtitle}
              </Text>
            </FlexItems>
          </Cell>
          <Cell>
            <RowButtons
              button1={row.button1}
              button2={row.button2}
              buttonStyle={row.color as any}
              justifyContent="flex-start"
            />
          </Cell>
        </Grid>
      </Main>
    </Box>
  );
};
export default CTASimple;
